<template>
    <span>
        <b-form-input
            :id="id"
            v-model="code"
            :state="state"
            aria-describedby="input-live-feedback"
            placeholder="Código"
            trim
            @input="notifyChange"></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback">
            La longitud no puede exceder 2 caracteres
        </b-form-invalid-feedback>
    </span>
</template>

<script>
    export default {
        name: "HeadquartersCodeInput",
        props: {
            value: String,
            id: String
        },
        data: function () {
            return {
                code: this.value
            }
        },
        computed: {
            state() {
                if (this.code === null) {
                    return null
                } else {
                    return !!this.code && this.code.length < 3;
                }
            }
        },
        methods: {
            notifyChange(code) {
                this.$emit('input', code);
            }
        },
        watch: {
            value: function () {
                this.code = this.value;
            }
        }
    }
</script>

<style scoped>

</style>